import {actions} from './actions'
import {mutations} from './mutations'
import {getters} from './getters'
import {Module} from 'vuex'
import {RootState} from '@/store'

export interface AuthorizationState {
    accessToken: string,
    refreshToken: string
}

export const initialState = function (): AuthorizationState {
    return {
        accessToken: '',
        refreshToken: ''
    }
}

export const authorization: Module<AuthorizationState, RootState> = {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}